export default defineNuxtRouteMiddleware((to, from) => {
  // console.log('loggedIn middleware', to, from)
  
  const visitorSession = useVisitorSession()
  // console.log('loggedIn middleware', visitorSession.loggedIn)
  
  if (!visitorSession.loggedIn) {
    useFullscreenLoading().stop()
    return '/'
  }
})
